import React from 'react';
import './Features.css';
import { SpeedIcon, ShieldIcon, TrendingIcon } from './Icons';

const Features = () => {
  const features = [
    {
      icon: <SpeedIcon size={48} color="#00d4ff" />,
      title: 'Fast Delivery',
      description: 'Within 5 to 10 minutes delivery. Get your Flash USDT quickly with our lightning-fast processing system.'
    },
    {
      icon: <ShieldIcon size={48} color="#00d4ff" />,
      title: 'Extended Validity',
      description: 'Validity: 15 to 30 days. Your Flash USDT remains active and usable for an extended period.'
    },
    {
      icon: <TrendingIcon size={48} color="#00d4ff" />,
      title: 'Unlimited Transfers',
      description: 'Transferable: Unlimited wallets. Send your Flash USDT to as many wallets as you need without restrictions.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <h2>Why Choose <span className="highlight">Flashseller.in</span></h2>
        <p className="section-subtitle">Your trusted partner for Flash USDT transactions</p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
